import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { IconButton } from "@mui/material";
import { Iconify } from "../../common/iconify";

export const SignInButton = ({ color = 'black' }) => {
    const { instance } = useMsal();

    const handleLogin = (loginType) => {
        if (loginType === "popup") {
            instance.loginPopup(loginRequest).catch(e => {
                console.log(e);
            });
        } else if (loginType === "redirect") {
            instance.loginRedirect(loginRequest).catch(e => {
                console.log(e);
            });
        }
    }
    return (
        <IconButton onClick={() => handleLogin("redirect")}>
            <Iconify icon='streamline:login-1-solid' width={40} color={color} />
        </IconButton>
    )
}